import React from 'react';
import cn from 'clsx';
import PropTypes from 'prop-types';

import Quantity from '../../library/quantity/quantity';

import styles from './miles-per-year-input.scss';

function MilesPerYearInput(props) {
  const {
    className = '',
    defaultValue,
    error,
    label,
    max,
    min,
    name,
    onBlur,
    onChange,
    value
  } = props;

  return (
    <div
      className={cn(styles['container'], `miles-per-year-input ${className}`)}
    >
      <span className={cn(styles['label'], 'miles-per-year-input__label')}>
        {label}
      </span>
      <Quantity
        className={cn(styles['input-field'], 'miles-per-year-input__quantity')}
        defaultValue={defaultValue}
        error={error}
        max={max}
        min={min}
        name={name}
        onBlur={onBlur}
        onChange={onChange}
        unit="K"
        value={value}
      />
    </div>
  );
}

MilesPerYearInput.propTypes = {
  className: PropTypes.string,
  defaultValue: PropTypes.number.isRequired,
  error: PropTypes.object,
  label: PropTypes.string,
  max: PropTypes.number.isRequired,
  min: PropTypes.number.isRequired,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.number.isRequired
};

export default MilesPerYearInput;
